import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() { this.timer = window.setTimeout(() => this.dismiss(), 6500) }
  disconnect() { window.clearTimeout(this.timer) }
  dismiss(event) {
    if (!event && this.element.contains(document.activeElement)) return
    this.element.remove()
  }
}
